import { atomFamily, useRecoilState } from 'recoil';
import { devError } from '../utils';
// this is needed to be able to share state between different components
// without constantly having to poll session storage
const sessionStorageRuntimeCache = atomFamily({
    key: '@zurich/common/hooks/sessionStorageRuntimeCache',
    default: (key) => {
        // load the initial value from session storage if available, otherwise return null
        if (typeof window === 'undefined') {
            return null;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        }
        catch (error) {
            devError(String(error));
            return null;
        }
    },
});
// adapted from https://usehooks.com/usesessionstorage
export function useSessionStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useRecoilState(sessionStorageRuntimeCache(key));
    // set a value in session storage and runtime cache
    const setValue = (value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
            }
        }
        catch (error) {
            devError(String(error));
        }
    };
    // here we handle the "null" returned from the runtime cache and return the initial value instead
    return [storedValue ?? initialValue, setValue];
}
